<template>
  <h4 :class="computedClass" :style="baseStyle">
    <slot />
  </h4>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { sizeByScreen, getFontSize } from './fontUtils'

interface Props {
  className?: string
}

const props = withDefaults(defineProps<Props>(), {
  className: ''
})

// Calcul des tailles de police pour chaque breakpoint
const baseFontSize = getFontSize('h4')
const mobileMFontSize = getFontSize('h4', sizeByScreen.mobile_m)
const mobileLFontSize = getFontSize('h4', sizeByScreen.mobile_l)
const tabletFontSize = getFontSize('h4', sizeByScreen.tablet)
const laptopFontSize = getFontSize('h4', sizeByScreen.laptop)
const laptopLFontSize = getFontSize('h4', sizeByScreen.laptop_l)
const screen4KFontSize = getFontSize('h4', sizeByScreen['4k_screen'])

const baseStyle = computed(() => ({
  fontSize: baseFontSize,
  lineHeight: '1.5'
}))

const computedClass = computed(() => {
  const classes = ['font-manrope']
  if (props.className) {
    classes.push(props.className)
  }
  return classes.join(' ')
})
</script>

<style scoped>
h4 {
  font-size: v-bind('baseFontSize');
  line-height: 1.5;
}

@media (min-width: 375px) {
  h4 {
    font-size: v-bind('mobileMFontSize');
  }
}

@media (min-width: 425px) {
  h4 {
    font-size: v-bind('mobileLFontSize');
  }
}

@media (min-width: 768px) {
  h4 {
    font-size: v-bind('tabletFontSize');
  }
}

@media (min-width: 1024px) {
  h4 {
    font-size: v-bind('laptopFontSize');
  }
}

@media (min-width: 1440px) {
  h4 {
    font-size: v-bind('laptopLFontSize');
  }
}

@media (min-width: 2560px) {
  h4 {
    font-size: v-bind('screen4KFontSize');
  }
}
</style>
